import CalculateMarginActions from "@frameworks/web/redux/feature/Tools/MarginCalculator/actions/CalculateMargin";
export default () => {
    return {
        marginCalculator: {
            calculateMargin: new CalculateMarginActions(),
        },
    };
};
